const Path = {
    localhost: 'http://localhost:8888/administrator',
    server: 'https://server.tender-yaratelle.ru/administrator'
}

export default Path.server
